import { render, staticRenderFns } from "./UploadAttach.vue?vue&type=template&id=4948f60c&scoped=true&"
import script from "./UploadAttach.vue?vue&type=script&lang=js&"
export * from "./UploadAttach.vue?vue&type=script&lang=js&"
import style0 from "./UploadAttach.vue?vue&type=style&index=0&id=4948f60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948f60c",
  null
  
)

export default component.exports